import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import submit from "submit-form";

const MealPlanTemplateProcessing = ({ template }) => {
  const { t } = useTranslation("coaching-portal");
  const {
    generation,
    _id: templateId,
  } = template;

  const handleStopGeneration = () => {
    const mealPlanId = templateId;
    const taskId = generation?.taskId || generation?._id || generation?.id;
    
    if (!taskId) {
      console.error("TaskId not found in generation object");
      return;
    }

    submit(`/actions/meal-planner/stop-meal-plan-generation`, {
      method: "POST",
      body: {
        taskId,
        mealPlanId,
      },
    });
  };

  return (
    <div className="processing-content">
      <div className="image-container">
        <div className="circle-background"></div>
        <img 
          src="/img/favicon/gemini.png" 
          alt={t("allTemplates.mealPlanProcessing.geminiIconAlt")} 
          className="gemini-image"
        />
      </div>
      <span className="processing-text">{t("allTemplates.mealPlanProcessing.generatingWithAI")}</span>
      <div className="gradient-bar">
        <div className="gradient-bar-fill"></div>
      </div>
      <button 
        type="button" 
        className="stop-generation-button"
        onClick={handleStopGeneration}
      >
        <img 
          src="/img/new-icons/red-cross.svg" 
          alt={t("allTemplates.mealPlanProcessing.stop")} 
          className="stop-icon"
        />
        <span>{t("allTemplates.mealPlanProcessing.stop")}</span>
      </button>
      {/* {generation?.status && (
        <div className="flex items-center gap-2 shrink-0">
          <AIStatusPill
            status={generation.status}
            error={generation.error}
          />
        </div>
      )} */}
    </div>
  );
};

MealPlanTemplateProcessing.propTypes = {
  template: PropTypes.object.isRequired,
};

export default MealPlanTemplateProcessing;

